import * as yup from 'yup'

export const ENTRY_ID = '5xGqxZgth5Dh8u9VIOYPkV'

export const fieldNames = ['CounselorLed', 'ImplementationType', 'TeacherLed']

export const validationSchema = yup.object().shape({
  ImplementationType: yup
    .string()
    .nullable()
    .required('Please select an option.'),
  CounselorLed: yup
    .boolean()
    .nullable()
    .test('leader-is-required', 'Please select at least one option.', function(
      value,
    ) {
      const { TeacherLed } = this.parent
      return !!value || !!TeacherLed
    }),
  TeacherLed: yup
    .boolean()
    .nullable()
    .test('leader-is-required', 'Please select at least one option.', function(
      value,
    ) {
      const { CounselorLed } = this.parent
      return !!value || !!CounselorLed
    }),
})
